import { getEachSiteRouteLayers } from './getEachSiteRouteLayers';

/**
 * @description data属性「filename」取得、bgに設定
 */

export const setBgImage = () => {
  const target = $('.js-bg');
  if (!target.length) return;

  const url = `/${getEachSiteRouteLayers()}/common/img/bg/`;

  target.each((i, e) => {
    const filename = $(e).data('filename');

    if (filename) $(e).css('background', `url(${url}${filename}.jpg) center center / cover no-repeat`);
  });
};
